import {getAllAxisURL} from "../../../services/api";
import {
    LOADING_AXIS,
    FETCH_ALL_AXIS, FETCH_ALL_AXIS_FAIL,
} from "../actionTypes";
import {checkErrorMessage} from "../../../utils/utils";
import api from '../../../services/instanceapi'

export const loadAllAxis = () => async (dispatch) => {
    dispatch({
        type: LOADING_AXIS
    });
    try {
        const axis = await api.get(getAllAxisURL());
        dispatch({
            type: FETCH_ALL_AXIS,
            payload: {
                axis: axis.data,
                status: axis.status,
                message: axis.statusText
            }
        })
        return Promise.resolve();
    } catch (e) {
        const message = checkErrorMessage(e)

        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_ALL_AXIS_FAIL,
                payload: {
                    message: message,
                    status: status
                },
            });
        }
    }
}